import { useMutation } from "react-query";
import api from "../../../service/api";

const url = process.env.REACT_APP_BASE_URL;

type Props = {
  clientId: string | number;
  resultId: string | number;
};
export const exportExcel = async ({ clientId, resultId }: Props) => {
  return await api.patch(
    `${url}/questionary/exportexcel/${clientId}/${resultId}`
  );
};

export function useExportExcel() {
  return useMutation(exportExcel, {
    onSuccess: () => {},
    onError: (error) => {
      console.log(error, "useExportExcel");
    },
  });
}
